import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { PropertyFacilitiesMapping, syncPropertyFacilities } from '~/services/AccommodationService';

interface SyncPropertyFacilitiesParams {
  propertyId: string;
  suppressNotifications?: boolean;
}

interface UseSyncPropertyFacilitiesOptions {
  onSuccess?: (facilities: PropertyFacilitiesMapping['facilities']) => void;
}

export function useSyncPropertyFacilities({ onSuccess }: UseSyncPropertyFacilitiesOptions = {}) {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ propertyId }: SyncPropertyFacilitiesParams) => {
      return syncPropertyFacilities({ propertyId });
    },
    onSuccess: (response, variables) => {
      if (response.result?.facilities?.length > 0) {
        onSuccess?.(response.result.facilities);
        if (!variables.suppressNotifications) {
          enqueueSnackbar('Facilities synced successfully', { variant: 'success' });
        }
      } else {
        if (!variables.suppressNotifications) {
          enqueueSnackbar(response.result?.message, { variant: 'error' });
        }
      }
    },
    onError: (error: Error, variables) => {
      if (!variables.suppressNotifications) {
        enqueueSnackbar(`Failed to sync facilities: ${error.message}`, { variant: 'error' });
      }
    },
  });
}
